import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <h1>agiagent.dev</h1>
      <p className="premium-domain">Premium Domain Opportunity</p>
    </section>
  );
};

export default Hero; 